import { Cog, ListChecks, ScrollText, Workflow } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const SECTIONS = [
  {
    icon: ListChecks,
    title: "Approvals queue",
    body: "Pending Telegram approvals with full diffs/SQL/commands inline, so you can ✅ from the laptop instead of mobile.",
  },
  {
    icon: Workflow,
    title: "Agent runs",
    body: "Live + historical CoS turns: tools called, tokens used, time spent, Langfuse trace per run.",
  },
  {
    icon: ScrollText,
    title: "System logs",
    body: "Tail of cos-hermes.service stdout/stderr, plus telemetry-relay error rates and recent ClickHouse insert latencies.",
  },
];

export default function Ops() {
  return (
    <div className="flex flex-col gap-6">
      <header className="flex items-center gap-3">
        <div className="grid h-10 w-10 place-items-center rounded-md bg-muted text-muted-foreground">
          <Cog className="h-5 w-5" />
        </div>
        <div>
          <h1 className="text-xl font-semibold">Ops</h1>
          <p className="text-sm text-muted-foreground">
            Operational view of CoS itself. Coming in v2.
          </p>
        </div>
      </header>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {SECTIONS.map((s) => (
          <Card key={s.title}>
            <CardHeader>
              <div className="flex items-center gap-2">
                <s.icon className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
                <CardTitle>{s.title}</CardTitle>
              </div>
              <CardDescription>v2</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">{s.body}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Until then</CardTitle>
          <CardDescription>
            Approvals still happen on Telegram. This page exists so v2 has a
            home to land in.
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}
